<template>
  <div class="container" style="background:#fff;padding:0px; ">
    <topOp> </topOp>
    <div class="row" style="position:relative;z-index:1">
      <div class="col-md-12">
        <div class="horasExtras">
          <h3 style="font-style:italic;">
            Férias: Faltas e Afastamentos
          </h3>
          <div class="formAjuste4">
            <p style="text-align:left;margin-bottom:-11px;padding:0px;">
              Início do período aquisitivo
            </p>
            <p>
              <label class="sr-only">Mes</label>
            </p>

            <div class="input-group mb-3 mr-sm-2">
              <div class="input-group-prepend">
                <div class="input-group-text">
                  <i class="fa fa-calendar" style="color:#808080;"></i>
                </div>
              </div>
              <input
                type="text"
                class="form-control formatacaoInput"
                v-model="inicio"
                placeholder="DD/MM/AAAA"
                maxlength="10"
              />
            </div>
            <p style="text-align:left;margin-bottom:-11px;padding:0px;">
              Fim do período aquisitivo
            </p>
            <p></p>
            <div class="input-group mb-3 mr-sm-2">
              <div class="input-group-prepend">
                <div class="input-group-text">
                  <i class="fa fa-calendar" style="color:#808080;"></i>
                </div>
              </div>
              <input
                type="text"
                class="form-control formatacaoInput"
                v-model="fim"
                placeholder="DD/MM/AAAA"
                maxlength="10"
              />
            </div>
            <p style="text-align:left;margin-bottom:-11px;padding:0px;">
              Nº de faltas no período aquisitivo
            </p>
            <p></p>
            <div class="input-group mb-3 mr-sm-2">
              <div class="input-group-prepend">
                <div class="input-group-text">
                  <i
                    class="fas fa-star-of-life"
                    style="font-size:16px;color:#808080;"
                  ></i>
                </div>
              </div>
              <input
                type="text"
                class="form-control formatacaoInput"
                v-model="faltaPeriodo"
              />
            </div>
            <p style="font-size:16px;">
              Houve afastamento por Auxílio-Doença/Acidente?
            </p>
            <div>
              <div class="row">
                <div class="radioMu" @click="exibirDivFunc()">
                  <div :class="radioMu2"></div>
                </div>
                <span style="margin-left:5px;margin-top:1px;">Sim</span>
                <div class="radioMu" @click="notexibirDivFunc()">
                  <div :class="radioMu3"></div>
                </div>
                <span style="margin-left:5px;margin-top:1px;">Não</span>
              </div>
              <br />
              <div v-if="exibirDiv" style="margin-bottom:20px;">
                <p>
                  Informar período de afastamento por Auxílio-Doença/Acidente
                </p>
                <p style="text-align:left;margin-bottom:-11px;padding:0px;">
                  Início
                </p>
                <p>
                  <label class="sr-only">Mes</label>
                </p>

                <div class="input-group mb-3 mr-sm-2">
                  <div class="input-group-prepend">
                    <div class="input-group-text">
                      <i class="fa fa-calendar" style="color:#808080;"></i>
                    </div>
                  </div>
                  <input
                    type="text"
                    class="form-control formatacaoInput"
                    v-model="inicio2"
                    placeholder="DD/MM/AAAA"
                    maxlength="10"
                  />
                </div>
                <p style="text-align:left;margin-bottom:-11px;padding:0px;">
                  Fim
                </p>
                <p></p>
                <div class="input-group mb-3 mr-sm-2">
                  <div class="input-group-prepend">
                    <div class="input-group-text">
                      <i class="fa fa-calendar" style="color:#808080;"></i>
                    </div>
                  </div>
                  <input
                    type="text"
                    class="form-control formatacaoInput"
                    v-model="fim2"
                    placeholder="DD/MM/AAAA"
                    maxlength="10"
                  />
                </div>
                <br />
                <br />
                <a href="#t"
                  ><button class="calcular" @click="incluir()">incluir</button>
                </a>
                <br />
                <br />
                <br />
                <table class="table-round-corner" id="t" cellspacing="0">
                  <tr style="height: 58px;">
                    <th>Início</th>
                    <th>Fim</th>
                    <th>Total</th>
                    <th>Período de Férias</th>
                  </tr>
                  <tr v-show="temConteudo" v-for="(l, i) in lista" :key="i">
                    <td>{{ l.dataI }}</td>
                    <td>{{ l.dataF }}</td>
                    <td>{{ l.faltas }}</td>
                    <td>{{ l.resultado }}</td>
                  </tr>
                  <tr v-show="inserir">
                    <td>
                      <b-spinner style="width: 1.5rem;height: 1.5rem;" small>
                      </b-spinner>
                    </td>
                    <td>
                      <b-spinner style="width: 1.5rem;height: 1.5rem;" small>
                      </b-spinner>
                    </td>
                    <td>
                      <b-spinner style="width: 1.5rem;height: 1.5rem;" small>
                      </b-spinner>
                    </td>
                    <td>
                      <b-spinner style="width: 1.5rem;height: 1.5rem;" small>
                      </b-spinner>
                    </td>
                  </tr>
                </table>

                <div v-if="!temConteudo">
                  <p style="margin:10px;font-size:20px;">
                    Nenhum Conteúdo Incluso
                  </p>
                </div>
              </div>
            </div>
            <br />
            <button class="limpar" @click="limpar()">Limpar</button>
            <a href="#horasExtrasResultado3">
              <button :disabled="disabled" class="calcular" @click="calcular()">
                calcular
                <b-spinner
                  v-show="spiner"
                  style="width: 1.5rem;
height: 1.5rem;"
                  small
                ></b-spinner></button
            ></a>
            <br />
            <br />
            <span style="color:red;" v-show="erro">{{ mensagemErro }}</span>
            <br />
          </div>
        </div>
      </div>
    </div>
    <div
      class="horasExtrasResultado"
      id="horasExtrasResultado3"
      style="background:#BEBEBE;"
    >
      <h3 style="font-style:italic;">
        Resultado do Cálculo
      </h3>
      <p style="color:#000;font-size:13px;text-align:left;">
        <strong
          >* análise, em separado, do reflexo nas férias das faltas
          injustificadas e do afastamento por Auxílio-Doença/Acidente</strong
        >
      </p>
      <div id="formAjuste2">
        <p class="pResultFaltas">
          Resultado análise período aquisitivo x faltas:
        </p>
        <input
          type="text"
          class="resultFaltas"
          :value="resultadoPeridoAquisitivo"
          disabled
        />
        <br />
        <br />
        <p v-show="exibirDiv" class="pResultFaltas">
          Resultado análise período aquisitivo x afastamento:
        </p>
        <input
          v-show="exibirDiv"
          type="text"
          class="resultFaltas"
          :value="resultadoPeridoAquisitivoAfastamento"
          disabled
        />
      </div>
      <h3 style="font-style:italic;">
        Notas
      </h3>
      <p align="justify" style="margin-top:10px;">
        1 - As faltas injustificadas do empregado ao trabalho, durante o período
        aquisitivo das férias, quando em número superior a cinco, fazem com que
        ele tenha direito ao gozo das férias com o número de dias reduzido,
        conforme artigo 130 da CLT. Observe-se que para a contagem do número de
        faltas injustificadas do empregado, para fins de aplicação do artigo 130
        da CLT, devem ser consideradas apenas as faltas injustificadas de
        jornadas completas que tenham ocorrido durante o período aquisitivo das
        férias.
      </p>
      <br />
      <p align="justify">
        2 - O afastamento em benefício de auxílio-doença (comum ou acidentário)
        determina a perda do direito às férias quando dentro do mesmo período
        aquisitivo de férias o empregado permanecer afastado por mais de 06
        meses. Para esta análise, o período de afastamento deve ser contado a
        partir da data do início do benefício previdenciário, ou seja, o período
        do atestado médico de 15 dias pago pela empresa, antes do início do
        benefício previdenciário, deve ser contado como período trabalhado.
        Ocorrendo a perda do direito às férias, inicia-se a contagem de um novo
        período aquisitivo de férias a partir da alta do benefício. Caso o
        afastamento em benefício de auxílio-doença (comum ou acidentário),
        dentro do período aquisitivo de férias, seja de até 06 meses, o
        empregado não perde o direito às férias do referido período aquisitivo,
        tendo direito ao período integral de férias (12/12 avos). (CLT, artigo
        133, inciso IV e § 2º).
      </p>
    </div>
  </div>
</template>

<script>
import services from "../services/services.js";
import topOp from "../shared/topOp.vue";
export default {
  components: {
    topOp: topOp,
  },
  data() {
    return {
      erro: false,
      disabled: false,
      spiner: false,
      inicio: "",
      fim: "",
      inicio2: "",
      fim2: "",
      faltaPeriodo: 0,
      resultadoPeridoAquisitivo: null,
      resultadoPeridoAquisitivoAfastamento: null,
      exibirDiv: false,
      radioMu2: "radioMu2",
      radioMu3: "radioMu3",
      lista: [],
      temConteudo: false,
      resAfastamento: [],
      lista2: [],
      inserir: false,
      mensagemErro: "Erro no cálculo. Por favor revise os campos!",
    };
  },
  methods: {
    async calcular() {
      this.disabled = true;
      this.spiner = true;
      this.resAfastamento = await services.getFaltasAfastamento(
        this.inicio,
        this.fim,
        this.faltaPeriodo,
        this.lista2
      );
      if (
        this.resAfastamento == undefined ||
        typeof this.resAfastamento == "string" ||
        this.resAfastamento.info == ""
      ) {
        typeof this.resAfastamento == "string"
          ? (this.mensagemErro = this.resAfastamento)
          : (this.mensagemErro =
              "Erro no cálculo. Por favor revise os campos!");
        this.erro = true;
        this.disabled = false;
        this.spiner = false;
        return;
      } else {
        this.resultadoPeridoAquisitivo = this.resAfastamento.info;
        this.erro = false;
      }
      this.resultadoPeridoAquisitivoAfastamento = this.resAfastamento.infoGrid;
      this.disabled = false;
      this.spiner = false;
    },
    async incluir() {
      if (this.inicio2.length == 10 && this.fim2.length == 10) {
        this.inserir = true;
        this.temConteudo = true;
        this.resAfastamento = await services.getFaltasAfastamento(
          this.inicio,
          this.fim,
          this.faltaPeriodo,
          [{ dataI: this.inicio2, dataF: this.fim2 }]
        );
        if (this.resAfastamento == undefined) {
          this.erro = true;
          this.inserir = false;
          return;
        }
        if (
          (typeof this.resAfastamento != "string" &&
            this.resAfastamento != undefined) ||
          !this.resAfastamento.infoGrid == ""
        ) {
          this.resAfastamento.lista.forEach((element) => {
            let dataFimp = element.dataFim.split(/(\d+):(\d+):(\d+)/);
            let dataIniciop = element.dataInicio.split(/(\d+):(\d+):(\d+)/);
            this.lista2.push({ dataI: dataIniciop[0], dataF: dataFimp[0] });
            this.lista.push({
              dataI: dataIniciop[0],
              dataF: dataFimp[0],
              faltas: element.faltas,
              resultado: element.resultado,
            });
            this.temConteudo = true;
            this.erro = false;
          });
        } else {
          this.erro = true;
          typeof this.resAfastamento == "string"
            ? (this.mensagemErro = this.resAfastamento)
            : (this.mensagemErro =
                "Erro no calculo. Por favor revise os campos!");
          this.inserir = false;
          if (this.lista.length < 1) {
            this.temConteudo = false;
          }
        }
        this.inserir = false;
        this.inicio2 = "";
        this.fim2 = "";
      }
    },
    limpar() {
      this.fim = "";
      this.fim2 = "";
      this.inicio = "";
      this.lista2 = [];
      this.inicio2 = "";
      this.faltaPeriodo = 0;
      this.lista = [];
      this.temConteudo = false;
      this.erro = false;
      this.resultadoPeridoAquisitivo = "";
      this.resultadoPeridoAquisitivoAfastamento = "";
    },
    exibirDivFunc() {
      this.radioMu2 = "radioMu3";
      this.radioMu3 = "radioMu2";
      this.exibirDiv = true;
    },
    notexibirDivFunc() {
      this.radioMu2 = "radioMu2";
      this.radioMu3 = "radioMu3";
      this.exibirDiv = false;
      this.fim2 = "";
      this.inicio2 = "";
    },
  },
  watch: {
    inicio(novo) {
      if (novo.length == 3 && !(novo[novo.length - 1] == "/")) {
        this.inicio = this.inicio.replace(/(\d{2})/, "$1/");
      } else if (novo.length == 6 && !(novo[novo.length - 1] == "/")) {
        this.inicio = this.inicio.replace(/((\d{2}).(\d{2}))/, "$1/");
      }
    },
    inicio2(novo) {
      if (novo.length == 3 && !(novo[novo.length - 1] == "/")) {
        this.inicio2 = this.inicio2.replace(/(\d{2})/, "$1/");
      } else if (novo.length == 6 && !(novo[novo.length - 1] == "/")) {
        this.inicio2 = this.inicio2.replace(/((\d{2}).(\d{2}))/, "$1/");
      }
    },
    fim(novo) {
      if (novo.length == 3 && !(novo[novo.length - 1] == "/")) {
        this.fim = this.fim.replace(/(\d{2})/, "$1/");
      } else if (novo.length == 6 && !(novo[novo.length - 1] == "/")) {
        this.fim = this.fim.replace(/((\d{2}).(\d{2}))/, "$1/");
      }
    },
    fim2(novo) {
      if (novo.length == 3 && !(novo[novo.length - 1] == "/")) {
        this.fim2 = this.fim2.replace(/(\d{2})/, "$1/");
      } else if (novo.length == 6 && !(novo[novo.length - 1] == "/")) {
        this.fim2 = this.fim2.replace(/((\d{2}).(\d{2}))/, "$1/");
      }
    },
  },
};
</script>

<style scoped>
.li {
  list-style: none;
}
.resultFaltas {
  width: 369px;
  height: 45px;
  border-radius: 10px;
  padding-left: 10px;
}
.abonoPecuniario {
  width: 20px;
  height: 20px;
  border: 1px solid red;
  display: inline-block;
}
#formAjuste2 {
  width: 369px;
  margin: 20px auto;
}
.pResultFaltas {
  text-align: left;
  margin-bottom: 5px;
  margin-top: 10px;
  margin-left: 4px;
}
.inputResult {
  width: 350px;
  height: 45px;
  border-radius: 10px;
  padding-left: 10px;
}
.radioMu2 {
  height: 24px;
  width: 24px;
  border-radius: 24px;
  border: 1px solid #707070;
  position: relative;
  left: 1px;
  top: 1px;
  cursor: pointer;
}
.radioMu2:hover {
  background: #f7b733;
  border: 1px solid #fff;
}
.radioMu3 {
  height: 24px;
  width: 24px;
  border-radius: 24px;
  border: 1px solid #707070;
  position: relative;
  left: 1px;
  top: 1px;
  cursor: pointer;
  background: #f7b733;
  border: 1px solid #fff;
}
.radioMu:hover {
  border: 1px solid #f7b733;
}
.radioMu {
  height: 28px;
  width: 28px;
  border-radius: 28px;
  border: 1px solid #707070;
  margin-left: 105px;
}
.container-flex {
  display: flex;
  flex-direction: row;
  justify-content: center;
  align-items: center;
}
.box {
  width: 360px;
  height: 45px;
  background: #fff;
}
.resultado {
  width: 407px;
  height: 45px;
  background: #fff;
}
.table-round-corner {
  margin-top: 15px;
  width: 800px;
  text-align: center;
  overflow: hidden;
  border-collapse: separate;
  border: solid #ccc 1px;
  border-radius: 15px;
  position: relative;
  left: -200px;
}
td {
  color: #383838;
  background-color: white;
  padding: 5px;
  border: 1px solid #ddd;
  color: #383838;
  font-size: 18px;
}
table th {
  color: white;
  background-color: #f7b733;
  font-weight: normal;
  text-align: center;
  padding: 5px;
  font-size: 25px;

  font-style: italic;
}
.calcular {
  float: right;
  background: #ff7835 0% 0% no-repeat padding-box;
  border: 2px solid #ff7835;
  border-radius: 5px;
  width: 170px;
  font-size: 21px;
  height: 48px;
  color: #fff;
  margin-top: -10px;
  font-weight: 600;
  cursor: pointer;
  font-style: italic;
}
.calcular:hover {
  background: #e64d00;
  border: 1px solid #e64d00;
}
.limpar {
  float: left;
  border: 2px solid #ff7835;
  border-radius: 5px;
  background: #fff;
  padding: 5px;
  font-weight: 500;
  font-size: 15px;
  width: 105px;
  cursor: pointer;
  font-style: italic;
}
input.formatacaoInput {
  /* border-right: 1px solid #707070;
  border-top: 1px solid #707070;
  border-bottom: 1px solid #707070; */
  border-radius: 10px;
  height: 43px;
}
.horasExtrasResultado {
  margin-top: 40px;
  padding-left: 110px;
  padding-right: 110px;
  padding-bottom: 30px;
  padding-top: 30px;
}
.input-group-text {
  border-left: 1px solid #707070;
  border-top: 1px solid #707070;
  border-bottom: 1px solid #707070;
  border-radius: 10px;
}
.horasExtras {
  padding-left: 110px;
  padding-right: 110px;
}
h3 {
  border-bottom: 1px solid #707070;
  padding-bottom: 6px;
  text-align: left;
  font-weight: bold;
  font-size: 26px;
}
.formAjuste4 {
  width: 370px;
  margin: 0px auto;
  padding-top: 40px;
}
input {
  border-right: 1px solid #707070;
  border-top: 1px solid #707070;
  border-bottom: 1px solid #707070;
}
@media only screen and (max-width: 1199px) {
  .pResult {
    margin-left: 5px;
  }
}
@media only screen and (max-width: 967px) {
  .inputResult {
    width: 250px;
  }
}
@media only screen and (max-width: 767px) {
  .horasExtras {
    margin-top: 445px;
  }
  .formAjuste4 {
    width: 320px;
  }
  .inputResult {
    width: 150px;
  }
}
@media only screen and (max-width: 767px) {
  .formAjuste4 {
    width: 300px;
    margin: 20px auto;
  }
  .horasExtras {
    padding-left: 80px;
  }
}
@media only screen and (max-width: 574px) {
  .inputResult {
    width: 340px;
  }
  .horasExtrasResultado {
    padding-left: 40px;
    padding-right: 170px;
  }
}
@media only screen and (max-width: 400px) {
  .formAjuste4 {
    width: 230px;
    margin: 20px auto;
  }
  .limpar {
    width: 88px;
  }
  .calcular {
    width: 126px;
    height: 37px;
    margin-top: 0px;
  }
  .inputResult {
    width: 280px;
  }
}
</style>



// WEBPACK FOOTER //
// src/screens/FaltasAfastamentos.vue